module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"@:labels.users"},"fr":{"title":"@:labels.users"}}')
  delete Component.options._Ctor
}
